import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FolderTabInfos } from 'src/app/models/folder-tab-infos';
import { FoldersListConfiguration } from 'src/app/models/folders-list-configuration';
import { ViewType } from 'src/app/models/server/enums/view-type';
import { View } from 'src/app/models/server/view';
import { ArchivingWorkflowDatasListComponent } from './archiving-workflow-datas-list/archiving-workflow-datas-list.component';
import { BoxDatasListComponent } from './box-datas-list/box-datas-list.component';
import { WorkflowDatasListComponent } from './workflow-datas-list/workflow-datas-list.component';

@Component({
    selector: 'app-folders-list-datas',
    templateUrl: './folders-list-datas.component.html',
    styleUrls: ['./folders-list-datas.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BoxDatasListComponent, WorkflowDatasListComponent, ArchivingWorkflowDatasListComponent]
})
export class FoldersListDatasComponent {
    @ViewChild(WorkflowDatasListComponent) workflowDatasListComponent: WorkflowDatasListComponent;
    @ViewChild(BoxDatasListComponent) boxDatasListComponent: BoxDatasListComponent;
    @ViewChild(ArchivingWorkflowDatasListComponent) archivingWorkflowDatasListComponent: ArchivingWorkflowDatasListComponent;

    ViewType = ViewType;

    @Input()
    public view: View;

    private configuration$ = new BehaviorSubject<FoldersListConfiguration>(null);

    @Input()
    set configuration(value) {
        this.configuration$.next(value);
    }

    get configuration() {
        return this.configuration$.getValue();
    }

    @Output()
    folderDisplayed: EventEmitter<FolderTabInfos> = new EventEmitter();

    /**
     * Appelé lorsque l'utilisateur consulte ou édite un dossier.
     * @param selector
     * @param view
     */
    onFolderDisplayed(selector: FolderTabInfos, view: View) {
        this.folderDisplayed.emit({
            folderId: selector.folderId,
            folderName: selector.folderName,
            view,
            readonly: selector.readonly,
        });
    }

    /**
     * Restaure la position de la barre de défilement (Utilisé lorsque l'on revient sur l'onglet de la liste après en avoir selectionné un autre). Sinon la barre de défilement est remise en haut.
     */
    public restoreScrollPosition() {
        if (this.view && this.view.viewType === ViewType.Workflow) {
            this.workflowDatasListComponent.restoreScrollPosition();
        } else if (this.view && this.view.viewType === ViewType.Box) {
            //this.boxDatasListComponent.restoreScrollPosition();
        } else if (this.view && this.view.viewType === ViewType.ArchivingWorkflow) {
            this.archivingWorkflowDatasListComponent.restoreScrollPosition();
        }
    }
}
